import { render, staticRenderFns } from "./AIKnowledge.vue?vue&type=template&id=93d0c4a0&scoped=true"
import script from "./AIKnowledge.vue?vue&type=script&lang=js"
export * from "./AIKnowledge.vue?vue&type=script&lang=js"
import style0 from "./AIKnowledge.vue?vue&type=style&index=0&id=93d0c4a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d0c4a0",
  null
  
)

export default component.exports